import { render, staticRenderFns } from "./DebrisConfig.vue?vue&type=template&id=c9e2f88a&scoped=true&"
import script from "./DebrisConfig.vue?vue&type=script&lang=js&"
export * from "./DebrisConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e2f88a",
  null
  
)

export default component.exports